// extracted by css-extract-rspack-plugin
export default {"cls1":"FullScreenPremiumModal-cls1_h-r","cls2":"FullScreenPremiumModal-cls2_i3X FullScreenPremiumModal-cls1_h-r"};